import { render } from "./newsletters.vue?vue&type=template&id=1084993a"
import script from "./newsletters.vue?vue&type=script&lang=js"
export * from "./newsletters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__